import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Icon from "../../../components/Library/Icon";

import styles from "./SavedStories.css";

var SavedStoriesEmpty = function SavedStoriesEmpty() {
  return React.createElement(
    "div",
    { className: styles.savedStoriesEmpty },
    React.createElement(
      "div",
      null,
      React.createElement(Icon, { name: "save", description: "Save story", className: styles.emptyIcon })
    ),
    React.createElement(
      "h3",
      { className: styles.emptyText },
      "You haven't saved any stories yet."
    ),
    React.createElement(
      "div",
      null,
      React.createElement(
        Link,
        { to: "/", className: classNames(styles.blueButton1, styles.emptyButton) },
        "Read top stories"
      )
    )
  );
};

export default SavedStoriesEmpty;


// WEBPACK FOOTER //
// ./src/users/components/SavedStories/SavedStoriesEmpty.js